import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';
import { CognitoUserPool } from "amazon-cognito-identity-js";
import { POOL_DATA, SHOPBYSTORE_URL } from "../../utils/config";
import { Tabs, message } from 'antd';
import { Helmet } from "react-helmet";

import SubHeader from './components/SubHeader';
import FilterHeader from './components/FilterHeader';
import FeaturedStores from './components/FeaturedStores';
import PartnerList from './components/PartnerList';
import FilteredResults from './components/FilteredResults';

import './Stores.css';
import noFilter from './components/imgs/no-filter.svg';

const TabPane = Tabs.TabPane;
class Stores extends Component {
  state = {
    username: '',
    logged: false,
    data: {},
    activeKey: '0',
    filteredStores: [],
    filter: false,
  };

  static getUserInfo() {
    try {
      const userPool = new CognitoUserPool(POOL_DATA);
      const cognitoUser = userPool.getCurrentUser();
      return cognitoUser.getUsername();
    } catch (e) {
      return null;
    }
  };

  getListWhileUserNotLogin() {
    const shopByStoreURL = `${SHOPBYSTORE_URL}`;
    fetch(shopByStoreURL, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(data => {
        this.setState({ data });
      })
      .catch(err => {
        message.error(String(err));
      })
  }

  getListWhileUserLoggedIn(username) {
    const shopByStoreURL = `${SHOPBYSTORE_URL}?userid=${username}`;
    fetch(shopByStoreURL)
      .then(res => res.json())
      .then(data => {
        this.setState({ data });
      })
      .catch(err => {
        message.error(String(err));
      })
  }

  componentDidMount() {
    const username = this.constructor.getUserInfo();
    this.setState({
      username,
    });
    if (username !== null && username.length === 40) {
      this.getListWhileUserLoggedIn(username);
    } else {
      this.getListWhileUserNotLogin();
    }
  }

  sort = (allStores)  => {
    allStores.sort((a, b) => {
      return a.storeName[0].toUpperCase() > b.storeName[0].toUpperCase();
    });

    let sortedStores = {'#': []};

    for (let i = 0; i < allStores.length; i++) {
      const c = allStores[i].storeName[0].toUpperCase();
      const reg= /^[A-Z]+$/;
      if (reg.test(c)) {
        if (sortedStores[c] && sortedStores[c].length >= 0)
          sortedStores[c].push(allStores[i]);
        else {
          sortedStores[c] = [];
          sortedStores[c].push(allStores[i]);
        }
      } else {
        sortedStores['#'].push(allStores[i]);
      }
    }

    if (sortedStores['#'].length === 0) { delete sortedStores['#']; }
    return sortedStores;
  };

  applyFilter = (selectedRegion, categories) => {
    if (selectedRegion.length !== 0 || categories.length !== 0) {
      this.setState({ filter: true });
    } else {
      this.setState({ filter: false })
    }
    let filteredStores = [];
    this.state.data.allStores.forEach(item => {
      let hasCategories = false;
      let hasRegions = false;
      item.categories.forEach(item => {
        if (categories.includes(item)) hasCategories = true;
      });
      item.regions.forEach(item => {
        if (selectedRegion.includes(item)) hasRegions = true;
      });
      if (hasCategories && hasRegions) filteredStores.push(item);
    });
    filteredStores = filteredStores.sort((a, b) => a.storeName >= b.storeName ? 1 : -1);
    this.setState({
      filteredStores: filteredStores.length !== 0 ? this.sort(filteredStores) : [],
      activeKey: '2',
    });
  };

  handleChangeTab = (activeKey) => {
    this.setState({ activeKey });
  };

  render() {
    let sortedStores;
    if (this.state.data.allStores !== undefined && this.state.data.allStores !== []) {
      sortedStores = this.sort(this.state.data.allStores);
    }

    const NoFilterApplied = () => (
      <div className='NoFilterApplied'>
        <img src={noFilter} alt="no filter applied"/>
        <div className='note'>
          <h3>{this.state.filter ? 'No Data' : 'No Filter Applied'}</h3>
          <span>{this.state.filter ? 'Tap "Filter" bar to change filters' : 'Tap "Filter" bar to apply a filter'} </span>
        </div>
      </div>
    );
    return (
      <div className='Stores'>
        <Helmet>
          <title>Stores - Qbates</title>
          <meta name="description" content="Find Your prefer stores and get cash back" />
        </Helmet>
        <SubHeader/>
        <FilterHeader apply={this.applyFilter.bind(this)}/>
        <div className="Main-tabs">
          <Tabs className="Store-tabs" activeKey={this.state.activeKey} onChange={this.handleChangeTab.bind(this)}>
            <TabPane tab="Featured Stores" key={'0'}>
              <FeaturedStores data={this.state.data} username={this.state.username}/>
            </TabPane>
            <TabPane tab="AllStores" key={'1'}>
              <PartnerList data={sortedStores} username={this.state.username}/>
            </TabPane>
            <TabPane tab="Filtered Results" key={'2'}>
              {this.state.filteredStores.length === 0 ? <NoFilterApplied/> : <FilteredResults data={this.state.filteredStores} username={this.state.username}/>}
            </TabPane>
          </Tabs>
        </div>
        <div className="Main-tabs-mobile">
          <Tabs className="Store-tabs" activeKey={this.state.activeKey} onChange={this.handleChangeTab.bind(this)}>
            <TabPane tab="Featured" key={'0'}>
              <FeaturedStores data={this.state.data} username={this.state.username}/>
            </TabPane>
            <TabPane tab="All" key={'1'}>
              <PartnerList data={sortedStores} username={this.state.username}/>
            </TabPane>
            <TabPane tab="Filtered" key={'2'}>
              {this.state.filteredStores.length === 0 ? <NoFilterApplied/> : <FilteredResults data={this.state.filteredStores} username={this.state.username}/>}
            </TabPane>
          </Tabs>
        </div>
      </div>
    )
  }
}

export default withRouter(Stores);


// WEBPACK FOOTER //
// ./src/Containers/Stores/Stores.js